import { useMutation } from '@tanstack/react-query';
import { authenticate } from '@repository/authenticateRepository';
import { toast } from 'react-toastify';
import useStartPage from '@components/features/startPageSwitch/hooks/useStartPage';
import { useTranslation } from 'react-i18next';
import { AuthenticateError, AuthenticateMutation, AuthenticateResponse } from '@models/authenticate/Authenticate';
import useAuthentication from '@hooks/useAuthentication';

const useAuthenticate = () => {
    const { startPage } = useStartPage();
    const { storeAccessToken } = useAuthentication();
    const { t } = useTranslation();

    return useMutation<AuthenticateResponse, AuthenticateError, AuthenticateMutation>({
        mutationFn: (mutation) => authenticate(mutation),
        onSuccess: (response) => {
            storeAccessToken('The user logged in', response.token);
            startPage?.navigate();
        },
        retry: 0,
        onError: (error) => {
            if (error.response?.status === 401) {
                toast.error(t('login.noPermission.toastError', { ns: 'authentication' }));
                return;
            }
            if (error.code === 'ERR_NETWORK') {
                toast.error(t('login.networkError.toastError', { ns: 'authentication' }));
                return;
            }
            toast.error(t('error'));
        },
    });
};

export default useAuthenticate;
